<template>
  <v-container fluid>
    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-col cols="12" style="margin-top: 2%">
        <!-- <template v-if="idCuadrillaSesion == ''">
          <v-text-field
            :append-icon="'mdi-eye'"
            v-model="Observacion"
            required
            label="Observacion"
            dense
            outlined
          ></v-text-field>
        </template> -->

        <template v-if="$store.getters.usuario.idRol == 4">
          <v-autocomplete
            v-model="listaAccionesSeleccionadas"
            :items="listaAcciones"
            item-value="idAccion"
            item-text="descripcion"
            attach
            chips
            prepend-icon="mdi-format-list-bulleted"
            label="Codigo de Cierre de Tareas"
            multiple
            persistent-hint
          >
          </v-autocomplete>
        </template>

        <template v-if="subAccionModel == true">
          <v-autocomplete
            v-model="subAccionesSeleccionadas"
            :items="listaSubAcciones"
            item-value="idSubAccion"
            item-text="descripcion"
            attach
            chips
            prepend-icon="mdi-format-list-bulleted"
            label="Codigo de Cierre de Sub Acciones"
            multiple
            persistent-hint
          >
          </v-autocomplete>
        </template>

        <v-card color="#1F7087">
          <v-card-title class="text-h5"> Agregar Materiales </v-card-title>
          <v-data-table
            :headers="cabeceras"
            :items="tablaMateriales"
            sort-by="Material"
            class="elevation-1"
            no-results-text="No se encontraron resultados"
            no-data-text="No ha cargado Ningun Dato"
            :footer-props="$store.state.traduccionTabla"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Materiales</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-tooltip bottom mg="1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="blue"
                      small
                      fab
                      dark
                      @click="agregarMaterialALaLista"
                      class="ml-2"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar Material</span>
                </v-tooltip>

                <v-dialog v-model="dialogMaterialDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Desea quitar este Material de la lista?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="eliminarMaterialConfirmar"
                        >Eliminar Material</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.MaterialSeleccionadoNombre`]="props">
              <v-autocomplete
                v-model="props.item.MaterialSeleccionadoNombre"
                :items="listaMateriales"
                item-value="idMaterial"
                :item-text="(item) => `${item.idMaterial} - ${item.nombre}`"
                label="Materiales"
                height="20"
                return-object
                @change="cambioMaterial(props.item)"
                no-data-text="No hay coincidencias"
                clearable
              ></v-autocomplete>
            </template>

            <template v-slot:[`item.cantidadActualOT`]="props">
              <template
                v-if="
                  props.item.MaterialSeleccionadoNombre &&
                  props.item.MaterialSeleccionadoNombre.nombre &&
                  props.item.MaterialSeleccionadoNombre.nombre.startsWith(
                    'Medidor'
                  ) &&
                  (props.item.MaterialSeleccionadoNombre.nombre
                    .toLowerCase()
                    .includes('tri') ||
                    props.item.MaterialSeleccionadoNombre.nombre
                      .toLowerCase()
                      .includes('mono'))
                "
              >
                <v-text-field
                  :value="
                    props.item.medidores ? props.item.medidores.length : 0
                  "
                  label="Cantidad Actual OT"
                  type="number"
                  readonly
                ></v-text-field>
              </template>
              <template v-else>
                <v-text-field
                  v-model="props.item.cantidadActualOT"
                  label="Cantidad Actual OT"
                  type="number"
                  readonly
                ></v-text-field>
              </template>
            </template>

            <template v-slot:[`item.CantidadIngresar`]="props">
              <template
                v-if="
                  props.item.MaterialSeleccionadoNombre &&
                  props.item.MaterialSeleccionadoNombre.nombre &&
                  props.item.MaterialSeleccionadoNombre.nombre.startsWith(
                    'Medidor'
                  ) &&
                  (props.item.MaterialSeleccionadoNombre.nombre
                    .toLowerCase()
                    .includes('tri') ||
                    props.item.MaterialSeleccionadoNombre.nombre
                      .toLowerCase()
                      .includes('mono'))
                "
              >
                <v-autocomplete
                  v-model="props.item.medidores"
                  :items="getMedidoresOrdenados(props.item)"
                  item-value="idMedidor"
                  item-text="nombre"
                  label="Seleccione los Medidores"
                  height="20"
                  return-object
                  no-data-text="No hay coincidencias"
                  clearable
                  multiple
                  chips
                  :loading="props.item.cargandoMedidores"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      {{ item.nombre }}
                    </v-chip>
                    <span v-if="index === 3">
                      +{{ props.item.medidores.length - 3 }} más
                    </span>
                  </template>
                </v-autocomplete>
              </template>
              <template v-else>
                <v-text-field
                  v-model="props.item.CantidadIngresar"
                  label="Cantidad"
                  clearable
                  type="number"
                ></v-text-field>
              </template>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom mg="1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    small
                    fab
                    dark
                    @click="eliminarMaterial(item)"
                    class="ml-2"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Material</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>

        <br />

        <v-card color="#1F7087">
          <v-card-title class="text-h5"> Agregar Bobinas </v-card-title>
          <v-data-table
            :headers="cabecerasBobinas"
            :items="tablaMaterialesBobinas"
            sort-by="Material"
            class="elevation-1"
            no-results-text="No se encontraron resultados"
            no-data-text="No ha cargado Ningun Dato"
            :footer-props="$store.state.traduccionTabla"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Bobinas</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-tooltip bottom mg="1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="blue"
                      small
                      fab
                      dark
                      @click="agregarMaterialBobinaALaLista"
                      class="ml-2"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar Bobina</span>
                </v-tooltip>

                <v-dialog v-model="dialogBobinaDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Desea quitar este Material de la lista?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="eliminarMaterialBobinaConfirmar"
                        >Eliminar Bobina</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <!-- <template v-slot:[`item.MaterialSeleccionadoNombre`]="props">
              <v-text-field
                v-model="props.item.MaterialSeleccionadoNombre"
                label="Material"
                type="text"
                readonly
              ></v-text-field>
            </template> -->

            <template v-slot:[`item.MaterialSeleccionadoNombre`]="props">
              <v-autocomplete
                v-model="props.item.MaterialSeleccionadoNombre"
                :items="listaMaterialesBobinas"
                item-value="idMaterialCable"
                :item-text="
                  (item) => `${item.idMaterialCable} - ${item.descripcionCable}`
                "
                label="Cable"
                height="20"
                return-object
                @change="cambioMaterialCable(props.item)"
                no-data-text="No hay coincidencias"
                clearable
              ></v-autocomplete>
            </template>

            <!-- <template v-slot:[`item.Bobina`]="props">
              <v-autocomplete
                v-model="props.item.Bobina"
                :items="listaMaterialesBobinasPrueba2"
                item-value="idBobinaC"
                item-text="idBobinaC"
                label="Bobinas"
                height="20"
                return-object
                @change="cambioMaterialBobina(props.item)"
                no-data-text="No hay coincidencias"
                clearable
              ></v-autocomplete>
            </template> -->

            <template v-slot:[`item.Bobina`]="props">
              <v-autocomplete
                v-model="props.item.Bobina"
                :items="props.item.Bobina"
                item-value="idBobinaC"
                item-text="idBobinaC"
                label="Bobinas"
                height="20"
                return-object
                no-data-text="No hay coincidencias"
                clearable
                @change="cambioBobinaCable(props.item)"
              ></v-autocomplete>
            </template>

            <template v-slot:[`item.cantidadDisponible`]="props">
              <v-text-field
                v-model="props.item.cantidadDisponible"
                label="Cantidad Disponible"
                type="number"
                readonly
              ></v-text-field>
            </template>

            <!-- <template v-slot:[`item.cantidadDisponible`]="props">
              <v-autocomplete
                v-model="props.item.Bobina"
                :items="listaMaterialesBobinas"
                item-value="idBobinaC"
                item-text="idBobinaC"
                label="Bobinas"
                height="20"
                return-object
                @change="cambioMaterialBobina(props.item)"
                no-data-text="No hay coincidencias"
                clearable
              ></v-autocomplete>
            </template> -->

            <template v-slot:[`item.secInicio`]="props">
              <v-text-field
                v-model="props.item.secInicio"
                label="Secuencia Inicio Disponible"
                type="number"
                readonly
              ></v-text-field>
            </template>

            <template v-slot:[`item.secFin`]="props">
              <v-text-field
                v-model="props.item.secFin"
                label="Secuencia Fin Disponible"
                type="number"
                readonly
              ></v-text-field>
            </template>

            <template v-slot:[`item.secInicioIngresar`]="props">
              <v-text-field
                v-model="props.item.secInicioIngresar"
                label="Secuencia Inicio"
                clearable
                type="number"
              ></v-text-field>
            </template>

            <template v-slot:[`item.secFinIngresar`]="props">
              <v-text-field
                v-model="props.item.secFinIngresar"
                label="Secuencia Fin"
                clearable
                type="number"
              ></v-text-field>
            </template>

            <template v-slot:[`item.cantidadTotalM`]="{ item }">
              <span>
                {{ Math.abs(item.secFinIngresar - item.secInicioIngresar) }}
              </span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom mg="1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    small
                    fab
                    dark
                    @click="eliminarMaterialBobina(item)"
                    class="ml-2"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Bobina</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>

        <template v-if="$store.getters.usuario.idRol == 4">
          <v-col cols="12" md="8">
            <v-card>
              <v-card-title class="text-h5">Tomar una Foto</v-card-title>
              <!-- <v-card-text>
                <canvas ref="canvas" style="display: none"></canvas>
                <template v-if="foto" class="mt-4">
                  <h3>Foto Capturada:</h3>
                  <v-img
                    :src="foto"
                    max-height="300"
                    max-width="100%"
                    contain
                  ></v-img>
                </template>
                <template v-else class="mt-4">
                  <video
                    ref="video"
                    autoplay
                    playsinline
                    style="width: 100%"
                  ></video>
                </template>
              </v-card-text> -->
              <v-card-actions>
                <!-- <v-btn color="primary" @click="capturarFoto">
                  Capturar Foto
                </v-btn> -->

                <!-- <v-file-input
                  accept="image/*"
                  v-model="foto"
                  prepend-icon="mdi-camera"
                  label="Foto"
                  @change="capturarFoto"
                >
                  ></v-file-input
                > -->

                <!-- <v-file-input
                  accept="image/*"
                  v-model="foto"
                  prepend-icon="mdi-camera"
                  label="Tomar foto o subir"
                /> -->

                <v-file-input
                  accept="image/*"
                  v-model="foto"
                  prepend-icon="mdi-camera"
                  label="Subir imagen o tomar foto"
                />
                <!-- :capture="esMovil ? 'environment' : null" -->

                <!-- <v-btn color="secondary" @click="reiniciarCamara" v-if="foto">
                  Reiniciar Cámara
                </v-btn>
                <v-btn color="info" @click="alternarCamara">
                  Cambiar Cámara
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-col>
        </template>

        <template v-if="idCuadrillaSesion == ''">
          <v-btn class="mt-5" color="primary" @click="armarCajon()">
            Armar Cajon
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            class="mt-5"
            color="primary"
            @click="finalizarTareaCuadrilla()"
          >
            Finalizar Tarea
          </v-btn>
        </template>
      </v-col>
    </v-form>
    <dialog-mensaje ref="dialogMensaje" @resultado="confirmarOperacion" />
  </v-container>
</template>

<script>
import axios from "axios";
import dialogMensaje from "@/components/modalMensaje.vue";
export default {
  components: {
    dialogMensaje,
  },
  data() {
    return {
      accionSeleccionada: [],
      subAccionesSeleccionadas: [],
      listaSubAcciones: [],
      subAccionModel: false,
      loading: false,
      listaMedidores: [],
      usandoCamaraFrontal: true,
      gpsActivo: false,
      watchId: null,
      foto: null,
      esMovil: false,
      //foto: require("@/assets/imagen.jpg"),
      videoStream: null,
      latitud: null,
      longitud: null,
      //latitud: "-27.780564",
      //longitud: "-64.259967",
      idOTTitulo: "",
      listaBobinas: [],
      listaAcciones: [],
      listaAccionesSeleccionadas: [],
      tablaVacia: 0,
      //idTarea: "",
      idTareaSeleccionada: "",
      idCuadrillaSesion: "",
      dialogMaterialDelete: false,
      dialogBobinaDelete: false,
      editedItem: {
        cantidad: 0,
        medida: "",
        MaterialSeleccionado: null,
        MaterialSeleccionadoNombre: null,
        MaterialSeleccionadoId: null,
        cantidadDisponible: 0,
        cantidadIngresar: 0,
      },
      Observacion: [],
      listaMaterialesBobinas: [
        {
          idMaterialCable: 1,
          descripcionCable: "Bobina 1",
        },
        {
          idMaterialCable: 2,
          descripcionCable: "Bobina 2",
        },
        {
          idMaterialCable: 3,
          descripcionCable: "Bobina 3",
        },
        {
          idMaterialCable: 4,
          descripcionCable: "Bobina 4",
        },
        {
          idMaterialCable: 5,
          descripcionCable: "Bobina 5",
        },
      ],
      listaMateriales: [
        {
          idMaterial: 1,
          nombre: "Material 1",
        },
        {
          idMaterial: 2,
          nombre: "Material 2",
        },
        {
          idMaterial: 3,
          nombre: "Material 3",
        },
        {
          idMaterial: 4,
          nombre: "Material 4",
        },
        {
          idMaterial: 5,
          nombre: "Material 5",
        },
      ],
      listaMaterialesBobinasPrueba2: [],
      listaMaterialesBobinasPrueba: [
        {
          cantidadMetros: 710,
          descripcionCable:
            "Cable de cobre concentrico monof.aisl.xlpe de  6+6  mm2 para 1,1 KV.",
          idBobina: 0,
          bobina: [
            {
              idBobinaC: "Y6585",
              secInicio: null,
              secFin: null,
            },
            {
              idBobinaC: "Y6587",
              secInicio: null,
              secFin: null,
            },
          ],
          idMaterialCable: 1060007,
          idOT: 339031,
          secFin: 0,
          secInicio: 0,
        },
        {
          cantidadMetros: 110,
          descripcionCable:
            "Cable de cobre preensamblado p/acometida de 4x 6 mm2",
          idBobina: 0,
          bobina: [
            {
              idBobinaC: "Y6586",
              secInicio: null,
              secFin: null,
            },
            {
              idBobinaC: "Y6588",
              secInicio: null,
              secFin: null,
            },
          ],
          idMaterialCable: 1060129,
          idOT: 339031,
          secFin: 0,
          secInicio: 0,
        },
      ],
      tablaMateriales: [],
      tablaMaterialesBobinas: [],
      cuadrillas: [],
      idTarea: "",
      cuadrillaSeleccion: "",
      formTitle: "",
      datosTarea: "",
      colorDialogTitle: "",
      dialog: false,
      formValid: null,
      alertShow: false,
      isSaving: false,
      show1: false,
      hintContratista: "Seleccione el contratista",
      contraseñaPH: "Contraseña",
      readonlyContrator: false,
      SeleccionContratista: "Selección",
      empleados: [],
      empleadoSeleccionados: [],
      contratistas: [],
      contratistaSeleccion: null,
      tipoModal_IdCuadrilla: 0,
      Usuario: "",
      password: "",
      NroOT: "",
      identificadorSeleccionado: null,
      cabeceras: [
        {
          text: "Material",
          value: "MaterialSeleccionadoNombre",
          class: "black white--text",
        },
        {
          text: "Cantidad Disponible OT",
          value: "cantidadActualOT",
          class: "black white--text",
        },
        {
          text: "Cantidad",
          value: "CantidadIngresar",
          class: "black white--text",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          class: "black white--text",
        },
      ],
      cabecerasBobinas: [
        {
          text: "Material",
          value: "MaterialSeleccionadoNombre",
          class: "black white--text",
        },
        {
          text: "Bobina / Vale",
          value: "Bobina",
          class: "black white--text",
        },
        {
          text: "Cantidad Disponible",
          value: "cantidadDisponible",
          class: "black white--text",
        },
        {
          text: "Secuencia Inicio Disponible",
          value: "secInicio",
          class: "black white--text",
        },
        {
          text: "Secuencia Fin Disponible",
          value: "secFin",
          class: "black white--text",
        },
        {
          text: "Secuencia Inicio",
          value: "secInicioIngresar",
          class: "black white--text",
        },
        {
          text: "Secuencia Fin",
          value: "secFinIngresar",
          class: "black white--text",
        },

        {
          text: "Cantidad de Metros",
          value: "cantidadTotalM",
          class: "black white--text",
        },
        {
          text: "Acciones",
          value: "actions",
          class: "black white--text",
        },
      ],
      Validaciones: {
        requeridoSelect: (v) =>
          v.length > 0 || "Debe seleccionar al menos un empleado",
        requerido: (v) => !!v || "Campo Requerido",
        requeridopassword: (v) => {
          if (v == null && this.tipoModal_IdCuadrilla === 0) {
            return "Mínimo 6 caracteres";
          }
          if (this.tipoModal_IdCuadrilla === 0) {
            !!v || "Campo Requerido";
          }
          if ((v == null || v === "") && this.tipoModal_IdCuadrilla > 0) {
            return true;
          } else if (v.length < 6) {
            return "Mínimo 6 caracteres";
          }

          return true;
        },
      },
    };
  },

  async mounted() {
    this.esMovil = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    console.log("La cantidad de materiales es");
    console.log(this.tablaMateriales.length);
    console.log("La lista de tareas es");
    console.log(this.$store.getters.listaTareas);
    const datos = this.$route.params.datos;
    console.log("Los datos recibidos son: ");
    console.log(datos);
    console.log(this.$store.getters.usuario.idContratista);
    if (datos != null) {
      this.idCuadrillaSesion = datos[0].idCuadrilla;
      this.idTareaSeleccionada = datos[0].idTarea;
      this.identificadorSeleccionado = datos[0].identificador;
    }

    console.log("cuadrilla sesion es");
    console.log(this.idCuadrillaSesion);
    console.log(this.identificadorSeleccionado);

    if (this.idCuadrillaSesion == "") {
      console.log("Ingreso en el cajon sin ser una cuadrilla");
      //await this.getListarCuadrillaByContratista();
      await this.getListarMaterialesContratista();
      await this.getListarMaterialesBobinasParaArmarCajonContratistaXOT();
    } else {
      await this.getListarMaterialesCajonCuadrilla();
      //await this.getListarMaterialesBobinasCuadrilla();
      await this.getListarMaterialesBobinasCajonCuadrilla();
      await this.getAcciones();
    }
  },

  computed: {
    ordenarMedidores(item) {
      if (!item || !item.medidores || !item.listaMedidores) return [];

      const seleccionados = item.medidores;
      const todos = item.listaMedidores;

      const idsSeleccionados = new Set(seleccionados.map((m) => m.idMedidor));

      const seleccionadosPrimero = todos.filter((m) =>
        idsSeleccionados.has(m.idMedidor)
      );
      const restantes = todos.filter((m) => !idsSeleccionados.has(m.idMedidor));

      return [...seleccionadosPrimero, ...restantes];
    },

    validarMaterial() {
      return (item) => {
        console.log("El material seleccionado en la primera tabla es: ");
        console.log(item);
        return this.listaMaterialesBobinas.some(
          (material) =>
            material.idMaterialCable.toString() ===
            item.MaterialSeleccionadoNombre?.idMaterial
        );
      };
    },

    cantidadMaterial() {
      var resultado = 0;
      return (item) => {
        // Si el material es válido
        if (this.validarMaterial(item)) {
          const materialEncontrado = this.tablaMaterialesBobinas.find(
            (material) =>
              material.MaterialSeleccionadoId.toString() ===
              item.MaterialSeleccionadoNombre?.idMaterial
          );

          if (materialEncontrado) {
            // Calcular la diferencia entre secInicio y secFin
            console.log("Hay materiales iguales: ");
            console.log(materialEncontrado);
            const diferencia =
              parseInt(materialEncontrado.secFinIngresar) -
              parseInt(materialEncontrado.secInicioIngresar);
            console.log(diferencia);
            item.cantidadIngresar = resultado;
            resultado = diferencia;
          }
        }
        console.log("El resultado es: ");
        console.log(resultado);
        return resultado;
      };
    },

    // cantidadMaterial() {
    //   return (item) => {
    //     // Verificar si el material es válido
    //     if (this.validarMaterial(item)) {
    //       const materialEncontrado = this.tablaMaterialesBobinas.find(
    //         (material) =>
    //           material.MaterialSeleccionadoId.toString() ===
    //           item.MaterialSeleccionadoNombre?.idMaterial
    //       );

    //       if (materialEncontrado) {
    //         // Calcular la diferencia entre secFinIngresar y secInicioIngresar
    //         const diferencia =
    //           parseInt(materialEncontrado.secFinIngresar) -
    //           parseInt(materialEncontrado.secInicioIngresar);
    //         return diferencia; // Retorna la diferencia
    //       }
    //     }
    //     return item.CantidadIngresar || 0; // Si no es válido, devuelve el valor existente
    //   };
    // },
  },
  beforeDestroy() {
    this.detenerCamara();
    this.detenerObservadorGPS(); // Detén el observador al destruir el componente
    if (this.timer) {
      clearTimeout(this.timer); // Limpia el temporizador
    }
  },

  watch: {
    async listaAccionesSeleccionadas() {
      this.subAccionModel = false;
      console.log("las acciones son:");

      for (const accionSeleccionada of this.listaAccionesSeleccionadas) {
        console.log(accionSeleccionada);
        if (accionSeleccionada === 32) {
          this.accionSeleccionada = accionSeleccionada;
          await this.getSubAcciones();
          this.subAccionModel = true;
        }
      }
    },
  },

  methods: {
    async getSubAcciones() {
      console.log("Ingresos a cargar las sub acciones de cajon cuadrilla");
      this.url =
        this.$store.state.urlBase +
        "Task/recuperarSubAcciones?idAccion=" +
        "32";
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de sub acciones de la cuadrilla es:");
        console.log(respuesta.data);
        this.listaSubAcciones = respuesta.data;
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getAcciones() {
      console.log("Ingresos a cargar las acciones de cajon cuadrilla");
      this.url = this.$store.state.urlBase + "Task/recuperarAcciones";
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Materiales del cajon de la cuadrilla es:");
        console.log(respuesta.data);
        this.listaAcciones = respuesta.data;
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    getMedidoresOrdenados(item) {
      if (this.$store.getters.usuario.idRol == 4) {
        console.log("LOs medidores para ordernar son:");
        console.log(item);
        if (!item) return [];

        if (item.medidores) {
          const seleccionados = item.medidores;
          const todos = item.listaMedidores;

          const idsSeleccionados = new Set(
            seleccionados.map((m) => m.idMedidor)
          );

          const seleccionadosPrimero = todos.filter((m) =>
            idsSeleccionados.has(m.idMedidor)
          );
          const restantes = todos.filter(
            (m) => !idsSeleccionados.has(m.idMedidor)
          );

          console.log("Los primeros campos elegidos son: ");
          console.log(seleccionadosPrimero);
          console.log("Los ultimos elegidos son: ");
          console.log(restantes);

          return [...seleccionadosPrimero, ...restantes];
        } else {
          return item.listaMedidores;
        }
      } else {
        console.log("LOs medidores para ordernar son:");
        console.log(item);
        if (!item) return [];

        if (item.medidores) {
          const seleccionados = item.medidores;
          const todos = item.listaMedidores;

          const idsSeleccionados = new Set(
            seleccionados.map((m) => m.idMedidor)
          );

          const seleccionadosPrimero = todos.filter((m) =>
            idsSeleccionados.has(m.idMedidor)
          );
          const restantes = todos.filter(
            (m) => !idsSeleccionados.has(m.idMedidor)
          );

          console.log("Los primeros campos elegidos son: ");
          console.log(seleccionadosPrimero);
          console.log("Los ultimos elegidos son: ");
          console.log(restantes);

          return [...seleccionadosPrimero, ...restantes];
        } else {
          return item.listaMedidores;
        }
      }
    },
    // cargarImagenPorDefecto() {
    //   this.foto = require("@/assets/imagen.jpg"); // Carga la imagen predeterminada
    // },
    detenerObservadorGPS() {
      if (this.watchId !== null) {
        navigator.geolocation.clearWatch(this.watchId); // Detiene el observador
        this.watchId = null;
        console.log("Observador GPS detenido.");
      }
    },

    verificarGPS() {
      if (!navigator.geolocation) {
        console.log("Ingreso en el si");
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "No ha activado el gps, por favor active el gps",
          1,
          "red",
          "Aviso"
        );
        this.gpsActivo = false;
        this.irAPaginaTareas();
      } else {
        console.log("Ingreso en el else");
        navigator.geolocation.getCurrentPosition(
          (position) => {
            console.log("Posición obtenida:", position);
            this.gpsActivo = true; // GPS activo
          },
          (error) => {
            console.error("Error de geolocalización:", error);
            this.gpsActivo = false;

            // Manejo de errores específicos
            if (error.code === error.PERMISSION_DENIED) {
              this.$refs.dialogMensaje.abrirMensajeDialog(
                "No ha permitido el uso del GPS. Por favor, conceda los permisos.",
                1,
                "red",
                "Aviso"
              );
            } else if (error.code === error.POSITION_UNAVAILABLE) {
              this.$refs.dialogMensaje.abrirMensajeDialog(
                "La ubicación no está disponible. Por favor, verifique el GPS.",
                1,
                "red",
                "Aviso"
              );
            } else if (error.code === error.TIMEOUT) {
              this.$refs.dialogMensaje.abrirMensajeDialog(
                "El tiempo de espera para obtener la ubicación ha expirado.",
                1,
                "red",
                "Aviso"
              );
            }
            this.irAPaginaTareas(); // Redirige si no se obtiene la posición
          },
          { enableHighAccuracy: true, timeout: 15000 }
        );
      }
    },

    // verificarGPS() {
    //   if (!navigator.geolocation) {
    //     console.log("Ingreso en el si");
    //     this.$refs.dialogMensaje.abrirMensajeDialog(
    //       "No ha activado el gps, por favor active el gps",
    //       1,
    //       "red",
    //       "Aviso"
    //     );
    //     this.gpsActivo = false;
    //     this.irAPaginaTareas();
    //   } else {
    //     console.log("Ingreso en el else");
    //     navigator.geolocation.watchPosition(
    //       (position) => {
    //         console.log("Posición obtenida:", position);
    //         this.gpsActivo = true; // GPS activo
    //         this.$refs.dialogMensaje.abrirMensajeDialog(
    //           "Posición obtenida: " + position,
    //           1,
    //           "green",
    //           "Aviso"
    //         );
    //       },
    //       (error) => {
    //         console.error("Error de geolocalización:", error);
    //         this.gpsActivo = false;

    //         // Manejo de errores específicos
    //         if (error.code === error.PERMISSION_DENIED) {
    //           this.$refs.dialogMensaje.abrirMensajeDialog(
    //             "No ha permitido el uso del GPS. Por favor, conceda los permisos.",
    //             1,
    //             "red",
    //             "Aviso"
    //           );
    //         } else if (error.code === error.POSITION_UNAVAILABLE) {
    //           this.$refs.dialogMensaje.abrirMensajeDialog(
    //             "La ubicación no está disponible. Por favor, verifique el GPS.",
    //             1,
    //             "red",
    //             "Aviso"
    //           );
    //         } else if (error.code === error.TIMEOUT) {
    //           this.$refs.dialogMensaje.abrirMensajeDialog(
    //             "El tiempo de espera para obtener la ubicación ha expirado.",
    //             1,
    //             "red",
    //             "Aviso"
    //           );
    //         }
    //         this.irAPaginaTareas(); // Redirige si no se obtiene la posición
    //       },
    //       { enableHighAccuracy: true, timeout: 15000 }
    //     );
    //   }
    // },

    verificarGPSYContinuar() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log("GPS activo. Ubicación:", position.coords);
          // Lógica para continuar con la siguiente acción
        },
        (error) => {
          console.error("Error de geolocalización:", error);
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "No se pudo obtener la ubicación. Por favor, verifica el GPS.",
            1,
            "red",
            "Error"
          );
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    },

    irAPaginaAnterior() {
      console.log("Ingreso en ir a la pagina anterior");
      setTimeout(() => {
        this.$router.go(-1); // Redirige a la página anterior
      }, 2000); // Espera para mostrar mensaje
    },

    irAPaginaTareas() {
      console.log("Ingreso en ir a tareas");
      setTimeout(() => {
        this.$router.push({ path: "/tareas" }); // Redirige a la ruta específica /tareas
      }, 2000); // Espera para mostrar mensaje
    },
    iniciarCamara() {
      const constraints = {
        video: {
          facingMode: this.usandoCamaraFrontal ? "user" : "environment",
        },
        audio: false,
      };

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.videoStream = stream;
          this.$refs.video.srcObject = stream;
        })
        .catch((error) => {
          console.error("Error al acceder a la cámara:", error);
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "No se pudo acceder a la cámara. Por favor, verifica los permisos.",
            1,
            "red",
            "Error"
          );
        });
    },
    async capturarFoto() {
      console.log("Ingreso en capturar foto");
      //await this.obtenerUbicacionActual();
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const context = canvas.getContext("2d");
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      this.foto = canvas.toDataURL("image/*");
      // this.foto = require("@/assets/imagen.jpg");
      //this.detenerCamara();
    },
    detenerCamara() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => track.stop());
        this.videoStream = null;
      }
    },
    reiniciarCamara() {
      this.foto = null;
      this.iniciarCamara();
    },
    alternarCamara() {
      this.usandoCamaraFrontal = !this.usandoCamaraFrontal;
      this.detenerCamara();
      this.iniciarCamara();
    },

    obtenerUbicacionActual() {
      console.log("Ingreso en la ubicacion actual");
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.latitud = position.coords.latitude;
            this.longitud = position.coords.longitude;
            console.log("Latitud:", this.latitud);
            console.log("Longitud:", this.longitud);
          },
          (error) => {
            console.error("Error obteniendo la ubicación:", error);
            switch (error.code) {
              case error.PERMISSION_DENIED:
                alert("Permiso de geolocalización denegado.");
                break;
              case error.POSITION_UNAVAILABLE:
                alert("Información de ubicación no disponible.");
                break;
              case error.TIMEOUT:
                alert("La solicitud de ubicación ha expirado.");
                break;
              default:
                alert("Ocurrió un error desconocido.");
                break;
            }

            this.irAPaginaTareas();
          }
        );
      } else {
        alert("La geolocalización no es soportada por este navegador.");
      }
      //this.capturarFoto();
    },

    confirmarCierreCuadrilla() {},

    async getListarMaterialesCajonCuadrilla() {
      console.log("Ingresos a cargar los materiales de cajon cuadrilla");
      this.url =
        this.$store.state.urlBase +
        "Material/recuperarMaterialesCajonCuadrilla?idCuadrilla=" +
        this.idCuadrillaSesion;
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Materiales del cajon de la cuadrilla es:");
        console.log(respuesta.data);
        this.listaMateriales = respuesta.data;
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getListarMaterialesBobinasParaArmarCajonContratistaXOT() {
      console.log("Ingresos a cargar los materiales bobinas para armar cajon");
      this.url =
        this.$store.state.urlBase +
        "Material/recuperarMaterialesBobinaParaArmarCajonContratistaXOT?idOT=" +
        this.idOTTitulo;
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log(
          "la lista de Materiales bobinas del cajon de la cuadrilla es:"
        );
        console.log(respuesta.data);
        console.log(JSON.stringify(respuesta.data));
        this.listaMaterialesBobinas = respuesta.data;
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }

      var listaMaterialesFiltrada = this.listaMateriales.filter(
        (material) =>
          !this.listaMaterialesBobinas.some(
            (bobina) => bobina.idMaterialCable == material.idMaterial
          )
      );

      this.listaMateriales = listaMaterialesFiltrada;

      console.log("La lista de materiales bobinas filtrada es:");
      console.log(listaMaterialesFiltrada);
    },

    async getListarMaterialesBobinasCajonCuadrilla() {
      console.log("Ingresos a cargar los materiales de cajon cuadrilla");
      this.url =
        this.$store.state.urlBase +
        "Material/recuperarMaterialesBobinasCajonCuadrilla?idCuadrilla=" +
        this.idCuadrillaSesion +
        "&idContratista=" +
        this.$store.getters.usuario.idContratista;
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log(
          "la lista de Materiales bobinas del cajon de la cuadrilla es:"
        );
        console.log(respuesta.data);
        this.listaMaterialesBobinas = respuesta.data;
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }

      // var listaMaterialesFiltrada = this.listaMateriales
      //   .Where(
      //     (material) =>
      //       !this.listaMaterialesBobinas.Any(
      //         (bobina) => bobina.idMaterialCable == material.idMaterial
      //       )
      //   )
      //   .ToList();

      // this.listaMateriales = listaMaterialesFiltrada;

      // console.log("La lista de materiales filtrada es:");
      // console.log(this.listaMateriales);
    },

    async getListarMaterialesBobinasContratistaXOT() {
      console.log("Ingresos a cargar los materiales de cajon cuadrilla");
      this.url =
        this.$store.state.urlBase +
        "Material/recuperarMaterialesBobinaContratistaXOT?idOT=" +
        this.idOTTitulo;
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Materiales bobinas del contratista es:");
        console.log(respuesta.data);
        this.listaMaterialesBobinas = respuesta.data;
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getListarMaterialesContratista() {
      // const idContratista =
      //   this.$store.getters.usuario.idContratista == null
      //     ? 2
      //     : this.$store.getters.usuario.idContratista;

      console.log("Ingresos a cargar los materiales del contratista");
      // this.url =
      //   this.$store.state.urlBase +
      //   "Material/recuperarMaterialesContratista?idContratista=" +
      //   idContratista;
      this.url =
        `${this.$store.state.urlBase}Material/recuperarMaterialesContratista` +
        `?idContratista=${this.$store.getters.usuario.idContratista}&idDistrito=${this.$store.getters.usuario.idDistrito}`;
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Material del contratista es:");
        console.log(respuesta.data);
        this.listaMateriales = respuesta.data;
        this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getListarMaterialesBobinasCuadrilla() {
      console.log("Ingresos a cargar las bobinas");
      console.log(this.$store.getters.usuario);
      this.url =
        this.$store.getters.urlBase +
        "Material/recuperarMaterialesBobinaParaResolverTareaCuadrilla?idCuadrilla=" +
        this.$store.getters.usuario.idCuadrilla;

      console.log("La url de recuperar bobinas es:");
      console.log(this.url);

      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Material bobina es:");
        console.log(respuesta.data);
        this.listaMaterialesBobinas = respuesta.data;
        this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }

      this.listaMateriales = this.listaMateriales.filter(
        (material) =>
          !this.listaMaterialesBobinas.some(
            (bobina) =>
              bobina.idMaterialCable.toString() === material.idMaterial
          )
      );
    },

    async getListarCuadrillaByContratista() {
      console.log("El contratista es");
      console.log(this.$store.getters.usuario.idContratista);

      if (this.$store.getters.usuario.idContratista == null) {
        this.$store.getters.usuario.idContratista == 2;
      }

      this.url =
        this.$store.getters.urlBase +
        "Cuadrilla?idContratista=" +
        this.$store.getters.usuario.idContratista;
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        // params: {
        //   idcontratista:
        //     this.$store.getters.usuario.idRol != 3
        //       ? this.contratistaSeleccion
        //       : this.$store.getters.idContratista,
        // },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);

      console.log("la lista de cuadrillas es:");
      console.log(respuesta.data);

      respuesta.data.forEach((item) => {
        console.log("El numero de cuadrilla es");
        console.log(item.cuadrilla);
        this.cuadrillas.push({
          nameCuadrilla: item.cuadrilla,
          idCuadrilla: item.idCuadrilla,
        });
      });
      console.log(this.cuadrillas);
    },

    async armarCajon() {
      var cantidadNegativa = 0;
      var sobreStock = 0;
      var bobinaIncorrecta = 0;
      var materialExcedido = "";

      if (
        this.tablaMateriales.length == 0 &&
        this.tablaMaterialesBobinas.length == 0
      ) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "No ha ingresado materiales",
          1,
          "red",
          "Aviso"
        );
        //this.mensajeError();
        return;
      }

      this.tablaMateriales.forEach((material, index) => {
        if (parseInt(material.CantidadIngresar) > material.cantidadActualOT) {
          console.log(material);
          console.log("Hay un material que excede el limite");
          console.log("El indece es:");
          console.log(index);
          console.log("La cantidad original es:");
          console.log(material.cantidad);
          console.log("La cantidad ingresar es:");
          console.log(material.cantidadIngresar);
          materialExcedido =
            material.MaterialSeleccionadoNombre.idMaterial +
            " - " +
            material.MaterialSeleccionadoNombre.nombre;
          sobreStock = 1;
          return;
        }
      });

      // this.tablaMateriales.forEach((material, index) => {
      //   if (material.CantidadIngresar > material.cantidad) {
      //     console.log("Hay un material que excede el limite");
      //     console.log(index);
      //     sobreStock = 1;
      //     return;
      //   }
      // });

      this.tablaMateriales.forEach((material, index) => {
        if (parseInt(material.CantidadIngresar) < 0) {
          console.log("Hay un material que excede el limite");
          console.log(index);
          cantidadNegativa = 1;
          return;
        }
      });

      this.tablaMaterialesBobinas.forEach((material) => {
        if (
          (material.secInicio != "Sin valor" &&
            material.secFin != "Sin valor") ||
          (material.secInicio == "" && material.secFin == "") ||
          (material.secInicio == null && material.secFin == null)
        ) {
          console.log("Los valores son de inicio y fin son: ");
          console.log(material.secInicioIngresar);
          console.log(material.secFinIngresar);
          console.log(material.secInicio);
          console.log(material.secFin);
          if (
            material.secFinIngresar != material.secFin &&
            material.secInicioIngresar != material.secFin &&
            material.secInicioIngresar != material.secInicio &&
            material.secFinIngresar != material.secInicio
          ) {
            console.log("La secuencia de la bobina es incorrecta");
            bobinaIncorrecta = 4;
          }
        } else {
          console.log("Ingreso en el else de la bobina");
          if (
            material.secFinIngresar > material.secFin ||
            material.secInicioIngresar > material.secFin ||
            material.secFinIngresar < material.secInicio ||
            material.secInicioIngresar < material.secInicio
          ) {
            bobinaIncorrecta = 2;
          }
        }

        // if (material.cantidadDisponible > material.secFinIngresar) {
        //   bobinaIncorrecta = 3;
        // }

        this.tablaMateriales.forEach((MaterialSeleccionado) => {
          console.log("El material seleccionado en el envio es: ");
          console.log(material);
          console.log(MaterialSeleccionado);
        });
      });

      if (cantidadNegativa == 1) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "No puede ingresar una cantidades negativas",
          2,
          "red",
          "Confirmacion"
        );
        return;
      }

      if (sobreStock == 1) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "El material " + materialExcedido + " excede el limite ",
          1,
          "red",
          "Aviso"
        );

        return;
      }
      console.log(bobinaIncorrecta);

      // if (bobinaIncorrecta == 2) {
      //   this.$refs.dialogMensaje.abrirMensajeDialog(
      //     "Las secuencias de inicio/fin deben de encontrarse dentro del rango correcto",
      //     1,
      //     "red",
      //     "Aviso"
      //   );
      //   return;
      // }

      // if (bobinaIncorrecta == 3) {
      //   this.$refs.dialogMensaje.abrirMensajeDialog(
      //     "La secuencia de fin no puede ser inferior a la cantidad de cable en la OT",
      //     1,
      //     "red",
      //     "Aviso"
      //   );

      //   return;
      // }

      // if (bobinaIncorrecta == 4) {
      //   this.$refs.dialogMensaje.abrirMensajeDialog(
      //     "Hay una bobina cuyo corte se realiza en el medio, debe elegir un extremo",
      //     1,
      //     "red",
      //     "Aviso"
      //   );

      //   return;
      // }

      console.log("El id de la cuadrilla seleccionada es: ");
      console.log(this.cuadrillaSeleccion);

      var respuesta;

      this.url = this.$store.state.urlBase + "Cajon/ingresarCajon";
      //this.url = this.$store.state.urlBas/api;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      console.log("lo que hay en tabla de materiales es");
      console.log(this.tablaMateriales);

      let datosMaterial = [];

      let datosMaterialBobina = [];

      let datosMedidores = [];

      this.tablaMateriales.forEach((material) => {
        console.log("El id del material es");
        console.log(material.MaterialSeleccionadoNombre.idMaterial);
        console.log("La cantidad del material es:");
        console.log(material.CantidadIngresar);
        if (material.medidores) {
          console.log("Es un medidor");
          material.medidores.forEach((medidor) => {
            datosMedidores.push({
              matricula: material.MaterialSeleccionadoNombre.idMaterial,
              idMedidor: medidor.idMedidor,
            });
          });
          datosMaterial.push({
            idMaterial: material.MaterialSeleccionadoNombre.idMaterial,
            cantidad: material.medidores.length,
          });
        } else {
          console.log("No Es un medidor");
          datosMaterial.push({
            idMaterial:
              material.MaterialSeleccionadoNombre.idMaterial.toString(),
            cantidad: material.CantidadIngresar,
          });
        }
      });

      // this.tablaMateriales.forEach((material) => {
      //   console.log("El id del material medidor es");
      //   console.log(material.MaterialSeleccionadoNombre.idMaterial);
      // });

      this.tablaMaterialesBobinas.forEach((material) => {
        console.log("El id del material bobina es");
        console.log(material);
        //console.log("La cantidad del material es:");
        //console.log(material.CantidadIngresar);
        datosMaterialBobina.push({
          idBobinaC: material.Bobina.idBobinaOriginal.toString(),
          secInicio: material.secInicioIngresar,
          secFin: material.secFinIngresar,
          idVale: material.idVale,
        });
      });

      console.log("Los materiales son:");
      console.log(datosMaterial);

      console.log("Los medidores son");
      console.log(datosMedidores);

      var datos = {
        idContratista:
          this.$store.getters.usuario.idContratista == null
            ? 2
            : this.$store.getters.usuario.idContratista,
        //idCuadrilla: this.cuadrillaSeleccion,
        idOT: this.idOTTitulo,
        listaMateriales: datosMaterial,
        listaBobinas: datosMaterialBobina,
        listaMedidores: datosMedidores,
        idUsuario: this.$store.getters.usuario.user_id,
        idDistrito: this.$store.getters.usuario.idDistrito,
      };

      console.log("Los datos son");

      console.log(datos);

      respuesta = await axios
        .post(this.url, datos, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de concluir tarea es:");

      console.log(respuesta);

      if (respuesta == true) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Se ha creado correctamente el cajon de materiales",
          1,
          "green",
          "Mensaje"
        );
      } else {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Ha ocurrido un problema",
          1,
          "red",
          "Aviso"
        );
      }

      this.$router.push({
        name: "Cajones",
      });
    },

    //confirmarOperacion() {},

    async finalizarTareaCuadrilla() {
      console.log("La cantidad de codigos es: ");
      //console.log(this.listaAccionesSeleccionadas.length);
      console.log(this.listaAccionesSeleccionadas);
      console.log(this.subAccionesSeleccionadas);
      console.log("La lista de bobinas es: ");
      console.log(this.tablaMaterialesBobinas);

      await this.obtenerUbicacionActual();

      if (this.foto == null) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Debe Ingresar una foto de la tarea",
          1,
          "red",
          "Aviso"
        );
        return;
      }

      if (this.listaAccionesSeleccionadas.length == 0) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Debe ingresar al menos un codigo de cierre",
          1,
          "red",
          "Aviso"
        );
      } else {
        if (this.tablaMateriales.length == 0) {
          this.tablaVacia = 1;
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Desea finalizar la tarea sin materiales?",
            2,
            "red",
            "Aviso"
          );
        } else {
          this.tablaVacia = 0;
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Desea Finalizar la tarea?",
            2,
            "red",
            "Aviso"
          );

          //this.confirmarOperacion(true);
        }
      }
    },

    async confirmarOperacion(resultadoFinal) {
      // console.log("Ingreso en confirmar operacion");
      // console.log(resultadoFinal);
      var sobreStock = 0;
      let idsVistos = new Set();
      var cantidadNegativa = 0;
      //var sobreStock = 0;
      var bobinaIncorrecta = 0;

      if (resultadoFinal == true) {
        let datosMaterialesBobinas = [];
        let datosMaterial = [];
        let datosMedidores = [];
        if (this.tablaVacia == 0) {
          this.tablaMateriales.forEach((material) => {
            if (
              parseInt(material.CantidadIngresar) > material.cantidadActualOT
            ) {
              console.log("El primer control");
              console.log(material);
              console.log(parseInt(material.CantidadIngresar));
              console.log(material.cantidadActualOT);
              console.log("Hay un material que excede el limite");
              sobreStock = 1;
              return;
            }
          });

          this.tablaMateriales.forEach((material) => {
            if (idsVistos.has(material.MaterialSeleccionadoNombre.idMaterial)) {
              console.log(
                "Se ha encontrado un ID de material duplicado:",
                material.MaterialSeleccionadoNombre.idMaterial
              );
              sobreStock = 2;
            } else {
              // Agregar el ID del material al conjunto de IDs vistos
              idsVistos.add(
                material.MaterialSeleccionadoNombre.idMaterial.toString()
              );
            }
          });

          if (sobreStock == 1) {
            this.$refs.dialogMensaje.abrirMensajeDialog(
              "Hay un/os material/es que excede el limite ",
              1,
              "red",
              "Aviso"
            );
            //this.mensajeError();
            return;
          }

          if (sobreStock == 2) {
            this.$refs.dialogMensaje.abrirMensajeDialog(
              "Hay un/os material/es repetidos ",
              1,
              "red",
              "Aviso"
            );
            //this.mensajeError();
            return;
          }

          this.tablaMaterialesBobinas.forEach((material) => {
            if (
              (material.secInicio != "Sin valor" &&
                material.secFin != "Sin valor") ||
              (material.secInicio == "" && material.secFin == "") ||
              (material.secInicio == null && material.secFin == null)
            ) {
              console.log("Los valores son de inicio y fin son: ");
              console.log(material.secInicioIngresar);
              console.log(material.secFinIngresar);
              if (
                Number(material.secInicioIngresar) >
                Number(material.secFinIngresar)
              ) {
                console.log(
                  "La cantidad ingresar es superior a la cantidad final"
                );
                bobinaIncorrecta = 1;
              }
              if (
                material.secFinIngresar < material.secFin &&
                material.secInicioIngresar > material.secInicio
              ) {
                console.log("La secuencia de la bobina es incorrecta");
                bobinaIncorrecta = 4;
              }
            } else {
              console.log("Ingreso en el else de la bobina");
              if (
                material.secFinIngresar > material.secFin ||
                material.secInicioIngresar < material.secInicio
              ) {
                bobinaIncorrecta = 2;
              }
            }

            this.tablaMateriales.forEach((MaterialSeleccionado) => {
              console.log("El material seleccionado en el envio es: ");
              console.log(material);
              console.log(MaterialSeleccionado);
            });
          });

          if (cantidadNegativa == 1) {
            this.$refs.dialogMensaje.abrirMensajeDialog(
              "No puede ingresar una cantidades negativas",
              2,
              "red",
              "Confirmacion"
            );
            return;
          }

          if (sobreStock == 1) {
            this.$refs.dialogMensaje.abrirMensajeDialog(
              "Hay un/os material/es que excede el limite ",
              1,
              "red",
              "Aviso"
            );
            //this.mensajeError();
            return;
          }

          console.log(bobinaIncorrecta);

          // if (bobinaIncorrecta == 1) {
          //   this.$refs.dialogMensaje.abrirMensajeDialog(
          //     "La secuencia de inicio no puede ser superior a la secuencia de fin",
          //     1,
          //     "red",
          //     "Aviso"
          //   );
          //   return;
          // }

          // if (bobinaIncorrecta == 2) {
          //   this.$refs.dialogMensaje.abrirMensajeDialog(
          //     "Las secuencias de inicio/fin deben de encontrarse dentro del rango correcto",
          //     1,
          //     "red",
          //     "Aviso"
          //   );
          //   return;
          // }

          // if (bobinaIncorrecta == 3) {
          //   this.$refs.dialogMensaje.abrirMensajeDialog(
          //     "La secuencia de fin no puede ser inferior a la cantidad de cable en la OT",
          //     1,
          //     "red",
          //     "Aviso"
          //   );
          //   return;
          // }

          // if (bobinaIncorrecta == 4) {
          //   this.$refs.dialogMensaje.abrirMensajeDialog(
          //     "Hay una bobina cuyo corte se realiza en el medio, debe elegir un extremo",
          //     1,
          //     "red",
          //     "Aviso"
          //   );
          //   return;
          // }

          console.log("lo que hay en tabla de materiales es");
          console.log(this.tablaMateriales);

          // this.tablaMateriales.forEach((material) => {
          //   console.log("El id del material es");
          //   console.log(material.MaterialSeleccionadoNombre.idMaterial);
          //   console.log("La cantidad del material es:");
          //   console.log(material.CantidadIngresar);
          //   datosMaterial.push({
          //     idMaterial:
          //       material.MaterialSeleccionadoNombre.idMaterial.toString(),
          //     cantidad: parseFloat(material.CantidadIngresar),
          //   });
          // });

          this.tablaMateriales.forEach((material) => {
            console.log("El id del material es");
            console.log(material.MaterialSeleccionadoNombre.idMaterial);
            console.log("La cantidad del material es:");
            console.log(material.CantidadIngresar);
            if (material.medidores) {
              console.log("Es un medidor");
              material.medidores.forEach((medidor) => {
                datosMedidores.push({
                  matricula: parseInt(
                    material.MaterialSeleccionadoNombre.idMaterial
                  ),
                  idMedidor: medidor.idMedidor,
                });
              });
              datosMaterial.push({
                idMaterial: material.MaterialSeleccionadoNombre.idMaterial,
                cantidad: material.medidores.length,
              });
            } else {
              console.log("No Es un medidor");
              datosMaterial.push({
                idMaterial:
                  material.MaterialSeleccionadoNombre.idMaterial.toString(),
                cantidad: material.CantidadIngresar,
              });
            }
          });

          this.tablaMaterialesBobinas.forEach((bobina) => {
            console.log("El id bobina es");
            console.log(bobina.Bobina.idBobinaC);
            console.log("La secuencia es:");
            console.log(bobina.secInicioIngresar);
            console.log(bobina.secFinIngresar);
            datosMaterialesBobinas.push({
              idBobinaC: bobina.Bobina.idBobinaC,
              secInicio: parseInt(bobina.secInicioIngresar),
              secFin: parseInt(bobina.secFinIngresar),
              idVale: bobina.Bobina.idVale,
            });
          });

          console.log("El id del coajo es:");
          console.log(
            this.tablaMateriales[0].MaterialSeleccionadoNombre.idCajon
          );
        }

        // console.log("La tabla de bobinas es:");

        // console.log(datosMaterialesBobinas);

        console.log("Antes de formData");

        console.log("Los materiales son:");
        console.log(datosMaterial);
        console.log("Los medidores son:");
        console.log(datosMedidores);

        const formData = new FormData();

        formData.append("idTarea", this.idTareaSeleccionada);
        formData.append(
          "idCajon",
          this.tablaVacia === 1
            ? 0
            : this.tablaMateriales[0].MaterialSeleccionadoNombre.idCajon
        );
        formData.append("materiales", JSON.stringify(datosMaterial));
        formData.append("listaMedidores", JSON.stringify(datosMedidores));
        formData.append("listaBobinas", JSON.stringify(datosMaterialesBobinas));
        this.listaAccionesSeleccionadas.forEach((codigo) => {
          formData.append("codigosTareas", codigo);
        });

        this.subAccionesSeleccionadas.forEach((codigo) => {
          formData.append("codigosSubAcciones", codigo);
        });

        console.log("Despues de asignar subacciones");

        console.log("Las acciones son: ");
        console.log(this.listaAccionesSeleccionadas);
        console.log("Las sub acciones son: ");
        console.log(this.subAccionesSeleccionadas);

        console.log("En this foto");
        console.log(this.foto);

        console.log("Antes de ingresara comprimir");

        const blobComprimido = await this.comprimirImagen(this.foto, 70);

        console.log("Despues de ingresar a comprimir");

        const fileComprimido = new File(
          [blobComprimido],
          "foto-comprimida.jpg",
          { type: "image/jpeg" }
        );
        try {
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Por favor aguarde mientras se realiza la operacion",
            1,
            "Blue",
            "Aviso"
          );

          formData.append(
            "fotoUrl",
            fileComprimido,
            `${this.idTareaSeleccionada}-${this.identificadorSeleccionado}` +
              this.extractExtFile(fileComprimido)
          );
          console.log("la foto comprimida es:");
          console.log(fileComprimido);
        } catch (error) {
          this.$refs.dialogMensaje.abrirMensajeDialog(
            error,
            1,
            "green",
            "Mensaje"
          );
          return;
        }

        formData.append("y", this.longitud.toString());
        formData.append("x", this.latitud.toString());
        formData.append("idUsuario", this.$store.getters.usuario.user_id);

        console.log("Los datos reales en FormData:");
        for (let pair of formData.entries()) {
          console.log(pair[0] + ": ", pair[1]);
        }

        var respuesta;

        this.url = this.$store.state.urlBase + "Task/concluirTareaCuadrilla";

        console.log("Datos antes del post:");
        for (let pair of formData.entries()) {
          console.log(pair[0] + ":", pair[1]);
        }

        const config = {
          headers: {
            //"Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
          },
        };

        console.log("Los datos antes del await:");
        console.log(formData);
        respuesta = await axios
          .post(this.url, formData, config)
          .then((response) => response.data)
          .catch((error) => {
            this.$refs.dialogMensaje.abrirMensajeDialog(
              error,
              1,
              "red",
              "Error"
            );
          });

        console.log("El resultado de la respuesta de concluir tarea es:");

        console.log(respuesta);

        if (respuesta == true) {
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Se ha concluido la tarea",
            1,
            "green",
            "Mensaje"
          );
          this.$router.push({
            name: "Tareas",
          });
        } else {
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Ha ocurrido un problema",
            1,
            "red",
            "Aviso"
          );
        }
        //this.$refs.dialogMensaje.cerrarModal();
      }
    },

    base64ToBlob(base64, mimeType) {
      const byteCharacters = atob(base64.split(",")[1]); // Extraer datos base64
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      return new Blob(byteArrays, { type: mimeType });
    },

    comprimirImagen(imagenComoArchivo, porcentajeCalidad) {
      return new Promise((resolve, reject) => {
        const $canvas = document.createElement("canvas");
        const imagen = new Image();
        imagen.onload = () => {
          $canvas.width = imagen.width;
          $canvas.height = imagen.height;
          $canvas.getContext("2d").drawImage(imagen, 0, 0);
          $canvas.toBlob(
            (blob) => {
              if (blob === null) {
                return reject(blob);
              } else {
                resolve(blob);
              }
            },
            "image/jpeg",
            porcentajeCalidad / 100
          );
        };
        imagen.src = URL.createObjectURL(imagenComoArchivo);
      });
    },

    extractExtFile(file) {
      if (file.type == "image/jpeg") {
        return ".jpg";
      }
      if (file.type == "image/png") {
        return ".png";
      }
      if (file.type == "application/pdf") {
        return ".pdf";
      }
    },

    async concluirTarea() {
      var respuesta;

      this.url = this.$store.state.urlBase + "Task/concluirTareaCuadrilla";

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      console.log("lo que hay en tabla de materiales es");
      console.log(this.tablaMateriales.MaterialSeleccionadoNombre);
      var datos = {
        Materiales: this.tablaMateriales.MaterialSeleccionadoNombre,
        idTarea: this.idTarea,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      console.log("Los datos son");

      console.log(datos);

      this.tablaMateriales.forEach((material) => {
        console.log("El material es:");
        console.log(material.MaterialSeleccionadoNombre);
        console.log(material.cantidad);
      });

      respuesta = await axios
        .post(this.url, config, datos)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de concluir tarea es:");

      console.log(respuesta);

      console.log(this.tablaTareasDespachadasCuadrilla);
    },

    editItem(item) {
      this.editedIndex = this.tablaMateriales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    eliminarMaterial(item) {
      this.editedIndex = this.tablaMateriales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogMaterialDelete = true;
    },

    eliminarMaterialBobina(item) {
      this.editedIndex = this.tablaMaterialesBobinas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogBobinaDelete = true;
    },

    eliminarMaterialBobinaConfirmar() {
      this.tablaMaterialesBobinas.splice(this.editedIndex, 1);
      this.closeDelete();
      //console.log("Esto hay en la tabla: ");
      //console.log(this.tablaMateriales);
    },
    eliminarMaterialConfirmar() {
      console.log("La tabla materiales");
      console.log(this.tablaMateriales[this.editedIndex]);
      console.log("La tabla materiales bobinas");
      console.log(this.tablaMateriales);

      this.tablaMateriales.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    closeDelete() {
      this.dialogMaterialDelete = false;
      this.dialogBobinaDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    // async cambioMaterial(item) {
    //   item.cantidad = item.MaterialSeleccionadoNombre.cantidad;
    //   console.log(
    //     "El material seleccionado es:",
    //     item.MaterialSeleccionadoNombre.idMaterial
    //   );

    //   if (
    //     item.MaterialSeleccionadoNombre.nombre.startsWith("Medidor") &&
    //     (item.MaterialSeleccionadoNombre.nombre.toLowerCase().includes("tri") ||
    //       item.MaterialSeleccionadoNombre.nombre.toLowerCase().includes("mono"))
    //   ) {
    //     console.log("Encontre un medidor");

    //     const medidores = await this.recuperarMedidoresXIdContratistaXMatricula(
    //       this.$store.getters.usuario.idContratista,
    //       item.MaterialSeleccionadoNombre.idMaterial
    //     );

    //     // if (Array.isArray(medidores)) {
    //     //   console.log("Es una lista");
    //     //   item.listaMedidores = medidores.map((num) => ({
    //     //     idMedidor: num,
    //     //     nombre: num.toString(),
    //     //   }));
    //     // } else {
    //     //   item.listaMedidores = [];
    //     // }

    //     item.listaMedidores = medidores.map((num) => ({
    //       idMaterial: num,
    //       nombre: num.toString(),
    //     }));

    //     console.log(
    //       "La nueva lista de medidores para este item es:",
    //       item.listaMedidores
    //     );
    //   } else {
    //     item.listaMedidores = []; // Asegurar que otros materiales no usen medidores
    //   }
    // },

    async cambioMaterial(item) {
      console.log("El material seleccionado es");
      console.log(item);

      //var materialRepetido;
      var mensaje;
      var cantidad;
      var materialRepetido = 0;
      this.$set(item, "cargandoMedidores", true);
      // Aquí puedes realizar la lógica para obtener la cantidad disponible
      // Supongamos que tienes una función obtenerCantidadDisponible() que obtiene la cantidad disponible

      this.tablaMateriales.forEach((material) => {
        console.log(material.MaterialSeleccionadoNombre.idMaterial);
        console.log(item.MaterialSeleccionadoNombre.idMaterial);
        if (
          item.MaterialSeleccionadoNombre.idMaterial ==
            material.MaterialSeleccionadoNombre.idMaterial &&
          this.tablaMateriales.length > 1
        ) {
          mensaje =
            "Ya existe en la lista un material con el codigo " +
            item.MaterialSeleccionadoNombre.idMaterial;
          materialRepetido = materialRepetido + 1;
          return;
        }
      });

      console.log("La cantidad es: ", cantidad);

      if (materialRepetido > 1) {
        this.tablaMateriales.splice(this.tablaMateriales.length - 1, 1);
        this.$refs.dialogMensaje.abrirMensajeDialog(mensaje, 1, "red", "Aviso");
        return;
      }

      try {
        if (this.$store.getters.usuario.idRol == 4) {
          item.cantidadActualOT = item.MaterialSeleccionadoNombre.cantidad;
        } else {
          item.cantidadActualOT =
            item.MaterialSeleccionadoNombre.cantidadActualOT;
        }

        console.log("El material seleccionado es:");
        console.log(item.MaterialSeleccionadoNombre.idMaterial);
        console.log(item.MaterialSeleccionadoNombre.nombre);
        console.log("La lista de materiales son: ");
        console.log(this.tablaMateriales);

        if (
          item.MaterialSeleccionadoNombre.nombre.startsWith("Medidor") &&
          (item.MaterialSeleccionadoNombre.nombre
            .toLowerCase()
            .includes("tri") ||
            item.MaterialSeleccionadoNombre.nombre
              .toLowerCase()
              .includes("mono"))
        ) {
          //console.log("Encontré un medidor");

          item.listaMedidores = [];
          await this.$nextTick();
          let medidores = [];

          if (this.$store.getters.usuario.idRol == 4) {
            medidores = await this.recuperarMedidoresXIdCuadrillaXMatricula(
              this.$store.getters.usuario.idCuadrilla,
              item.MaterialSeleccionadoNombre.idMaterial
            );
          } else {
            medidores = await this.recuperarMedidoresXIdContratistaXMatricula(
              this.$store.getters.usuario.idContratista,
              item.MaterialSeleccionadoNombre.idMaterial
            );
          }

          // Transformar números en objetos
          item.listaMedidores = medidores.map((num) => ({
            idMedidor: num,
            nombre: num.toString(),
          }));

          this.$set(
            item,
            "listaMedidores",
            medidores.map((num) => ({
              idMedidor: num,
              nombre: num.toString(),
            }))
          );

          console.log("La nueva lista de medidores es:", item.listaMedidores);
        }
      } catch (error) {
        console.error("Error al recuperar medidores:", error);
        this.$set(item, "listaMedidores", []);
      } finally {
        console.log("Ingreso en el finally");
        this.$set(item, "cargandoMedidores", false);
      }
    },

    async recuperarMedidoresXIdContratistaXMatricula(
      idContratista,
      idMaterial
    ) {
      var respuesta;

      this.url =
        `${this.$store.state.urlBase}Material/recuperarMedidoresXIdContratistaXMatricula` +
        `?idContratista=${this.$store.getters.usuario.idContratista}&matricula=${idMaterial}`;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      this.listaMedidores = respuesta;

      console.log(
        "El resultado de la respuesta de recuperar medidores contratista es:"
      );
      console.log(this.listaMedidores);

      // console.log(
      //   "Tipo de datos de this.listaMedidores:",
      //   typeof this.listaMedidores
      // );

      // if (Array.isArray(this.listaMedidores)) {
      //   console.log("this.listaMedidores es un array.");
      //   console.log("Longitud del array:", this.listaMedidores.length);
      // } else {
      //   console.log("this.listaMedidores no es un array.");
      //   console.log("Contenido de this.listaMedidores:", this.listaMedidores);
      // }
      return this.listaMedidores;
    },

    async recuperarMedidoresXIdCuadrillaXMatricula(idCuadrilla, idMaterial) {
      var respuesta;

      this.url =
        `${this.$store.state.urlBase}Material/recuperarMedidoresXIdCuadrillaXMatricula` +
        `?idCuadrilla=${this.$store.getters.usuario.idCuadrilla}&matricula=${idMaterial}`;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      this.listaMedidores = respuesta;

      console.log(
        "El resultado de la respuesta de recuperar medidores cuadrilla es:"
      );
      console.log(this.listaMedidores);

      // console.log(
      //   "Tipo de datos de this.listaMedidores:",
      //   typeof this.listaMedidores
      // );

      // if (Array.isArray(this.listaMedidores)) {
      //   console.log("this.listaMedidores es un array.");
      //   console.log("Longitud del array:", this.listaMedidores.length);
      // } else {
      //   console.log("this.listaMedidores no es un array.");
      //   console.log("Contenido de this.listaMedidores:", this.listaMedidores);
      // }
      return this.listaMedidores;
    },

    // cambioMaterialCable(item) {
    //   console.log(item);
    //   const ocurrencias = this.listaMaterialesBobinasPrueba.filter(
    //     (bobina) =>
    //       bobina.idMaterialCable ===
    //       item.MaterialSeleccionadoNombre.idMaterialCable
    //   ).length;

    //   console.log("La cantidad de ocurrencias es:");
    //   console.log(ocurrencias);
    //   item.cantidadDisponible = item.MaterialSeleccionadoNombre.cantidadMetros;
    //   // if (ocurrencias == 1) {
    //   //   item.cantidadDisponible =
    //   //     item.MaterialSeleccionadoNombre.cantidadMetros;
    //   //   //item.Bobina = item.MaterialSeleccionadoNombre.idBobinaC;
    //   // } else {
    //   //   this.listaMaterialesBobinasPrueba2 = this.listaMaterialesBobinasPrueba
    //   //     .filter(
    //   //       (bobina) =>
    //   //         bobina.idMaterialCable ===
    //   //         item.MaterialSeleccionadoNombre.idMaterialCable
    //   //     )
    //   //     .map((bobina) => bobina.idBobinaC);

    //   //   console.log("Lista de idBobinaC:", this.listaMaterialesBobinasPrueba2);
    //   // }
    //   item.listaMaterialesBobinasPrueba2 =
    //     item.MaterialSeleccionadoNombre.bobina;
    // },

    cambioMaterialCable(item) {
      // Buscar el material seleccionado en la listaMaterialesBobinasPrueba
      const materialSeleccionado = this.listaMaterialesBobinas.find(
        (material) =>
          material.idMaterialCable ===
          item.MaterialSeleccionadoNombre.idMaterialCable
      );
      console.log("El cable seleccionado es:");
      console.log(materialSeleccionado.bobina);

      item.cantidadDisponible = materialSeleccionado.cantidadMetros;
      // Si se encuentra el material, cargar las bobinas asociadas en la segunda columna
      if (materialSeleccionado) {
        // Cargar las bobinas dentro de la propiedad Bobina del item
        this.listaBobinas = materialSeleccionado.bobina;
        item.Bobina = materialSeleccionado.bobina;
        console.log("Bobina cargadas:", item.Bobina);
      } else {
        // Si no se encuentra un material, vaciar la lista de bobinas
        item.Bobina = [];
      }
    },

    cambioBobinaCable(item) {
      var mensaje = "";
      var materialRepetido = 0;

      console.log("Las bobinas de la tabla son:");

      this.tablaMaterialesBobinas.forEach((material) => {
        console.log(material.Bobina.idBobinaC);
        console.log(item.Bobina.idBobinaC);
        if (
          item.Bobina.idBobinaC == material.Bobina.idBobinaC &&
          this.tablaMaterialesBobinas.length > 1
        ) {
          mensaje =
            "Ya existe en la lista una bobina con el codigo " +
            item.Bobina.idBobinaC;
          materialRepetido = materialRepetido + 1;
          return;
        }
      });

      //console.log("La cantidad es: ", cantidad);

      if (materialRepetido > 1) {
        this.tablaMaterialesBobinas.splice(
          this.tablaMaterialesBobinas.length - 1,
          1
        );
        this.$refs.dialogMensaje.abrirMensajeDialog(mensaje, 1, "red", "Aviso");
        return;
      }

      if (item.Bobina) {
        console.log("Bobina seleccionada:", item.Bobina);

        // Calcula la cantidad disponible basándote en las secciones de la bobina
        if (item.Bobina.secFin == 0 && item.Bobina.secInicio == 0) {
          item.cantidadDisponible = item.Bobina.cantidadMetros;
          item.secInicio = "Sin Valor";
          item.secFin = "Sin Valor";
          item.idVale = item.Bobina.idVale;
        } else {
          item.cantidadDisponible = item.Bobina.secFin - item.Bobina.secInicio;
          item.secInicio = item.Bobina.secInicio;
          item.secFin = item.Bobina.secFin;
          item.idVale = item.Bobina.idVale;
        }

        // Si necesitas asegurarte de que se esté creando una nueva referencia, podrías hacer lo siguiente:
        //item.Bobina = { ...item.Bobina };
        //item.Bobina = this.listaBobinas;
      } else {
        // En caso de que no haya una bobina seleccionada, limpia los valores
        item.cantidadDisponible = 0;
        item.idVale = 0;
        item.secInicio = null;
        item.secFin = null;
      }

      console.log("La cantidad Disponible es: ");
      console.log(item.cantidadDisponible);

      console.log("La tabla de bobinas es:");
      console.log(item.tablaMaterialesBobinas);
    },

    cambioMaterialBobina(item) {
      console.log(item);
      item.cantidadDisponible = item.MaterialSeleccionadoNombre.cantidadMetros;
      item.Bobina = item.MaterialSeleccionadoNombre.idBobinaC;
      item.Bobina = this.listaBobinas;

      // const materialEncontrado = this.listaMaterialesBobinas.find(
      //   (bobina) => bobina.idBobinaC === item.Bobina.idBobinaC
      // );

      // if (materialEncontrado) {
      //   const idMaterialCable = materialEncontrado.idMaterialCable;
      //   console.log("idMaterialCable encontrado:", idMaterialCable);
      //   return idMaterialCable;
      // } else {
      //   console.log("No se encontró el idMaterialCable correspondiente.");
      //   return null;
      // }
    },

    vaciarEditedItem() {
      this.editedItem = {
        cantidad: 0,
        medida: "",
        MaterialSeleccionado: null,
        MaterialSeleccionadoNombre: null,
        MaterialSeleccionadoId: null,
        cantidadDisponible: 0,
        cantidadIngresar: 0,
      };
    },

    agregarMaterialBobinaALaLista(material) {
      console.log("La cantidad de materiales es");
      console.log(this.tablaMateriales.length);
      console.log("Ingreso en agregar bobina a la lista");
      if (this.editedIndex > -1) {
        Object.assign(
          this.tablaMaterialesBobinas[this.editedIndex],
          this.editedItem
        );
      } else {
        console.log("El ultimo registro es: ");
        console.log(
          this.tablaMaterialesBobinas[this.tablaMaterialesBobinas.length - 1]
        );
        if (this.tablaMaterialesBobinas.length == 0) {
          console.log("No hay registros en la tabla");
          this.vaciarEditedItem();
          this.tablaMaterialesBobinas.push(this.editedItem);
          // Cambia MaterialSeleccionado a MaterialSeleccionadoNombre
          this.tablaMaterialesBobinas[
            this.tablaMaterialesBobinas.length - 1
          ].MaterialSeleccionadoNombre = material.nombre;
          this.tablaMaterialesBobinas[
            this.tablaMaterialesBobinas.length - 1
          ].MaterialSeleccionadoId = material.idMaterial;
        } else {
          console.log("Ya hay registros");
          if (
            this.tablaMaterialesBobinas[this.tablaMaterialesBobinas.length - 1]
              .MaterialSeleccionadoNombre != null
          ) {
            console.log("Ha ingresado material en la tabla");
            if (
              this.tablaMaterialesBobinas[
                this.tablaMaterialesBobinas.length - 1
              ].secInicioIngresar != null ||
              this.tablaMaterialesBobinas[
                this.tablaMaterialesBobinas.length - 1
              ].secFinIngresar != null
            ) {
              console.log("Ha una cantidad distinta de null");
              if (
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].secInicioIngresar != 0 ||
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].secFinIngresar != 0
              ) {
                console.log("Ha una cantidad distinta de 0");
                this.vaciarEditedItem();
                this.tablaMaterialesBobinas.push(this.editedItem);
                // Cambia MaterialSeleccionado a MaterialSeleccionadoNombre
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].MaterialSeleccionadoNombre = material.nombre;
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].MaterialSeleccionadoId = material.idMaterial;
              }
            }
          }
        }
      }
      console.log("Estoy hay en la tabla de bobinas: ");
      console.log(this.tablaMaterialesBobinas);
    },
    agregarMaterialALaLista() {
      console.log("La cantidad de materiales es");
      console.log(this.tablaMateriales.length);
      console.log("Ingreso en agregar a la lista");
      console.log(this.editedItem);
      if (this.editedIndex > -1) {
        Object.assign(this.tablaMateriales[this.editedIndex], this.editedItem);
      } else {
        console.log("El ultimo registro es: ");
        console.log(this.tablaMateriales[this.tablaMateriales.length - 1]);
        if (this.tablaMateriales.length == 0) {
          console.log("No hay registros en la tabla");
          //console.log("El item a ingresar es: ");
          //this.vaciarEditedItem();
          //console.log(this.editedItem);
          this.tablaMateriales.push(this.editedItem);
        } else {
          console.log("Ya hay registros");
          if (
            this.tablaMateriales[this.tablaMateriales.length - 1]
              .MaterialSeleccionadoNombre != null
          ) {
            console.log("Ha ingresado material en la tabla");
            console.log(
              this.tablaMateriales[this.tablaMateriales.length - 1]
                .CantidadIngresar
            );
            if (
              this.tablaMateriales[this.tablaMateriales.length - 1]
                .CantidadIngresar != null ||
              this.tablaMateriales[this.tablaMateriales.length - 1].medidores
                .length != 0
            ) {
              console.log("Ha una cantidad distinta de null");
              if (
                this.tablaMateriales[this.tablaMateriales.length - 1]
                  .CantidadIngresar != 0 ||
                this.tablaMateriales[this.tablaMateriales.length - 1].medidores
                  .length != 0
              ) {
                console.log("Ha una cantidad distinta de 0");
                this.vaciarEditedItem();
                //console.log(this.editedItem);
                this.tablaMateriales.push(this.editedItem);
              }
            }
            //console.log("El item a ingresar es: ");
          }
          // this.vaciarEditedItem();
          // //console.log(this.editedItem);
          // this.tablaMateriales.push(this.editedItem);
        }
      }
      console.log("Estoy hay en la tabla de materiales: ");
      console.log(this.tablaMateriales);
      //if (this.tablaMateriales[this.tablaMateriales.length].MaterialSeleccionadoNombre.idMaterial)
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    abrirModalTareaCuadrilla(datos) {
      this.datosTarea = datos;
      this.colorDialogTitle = "green";
      //this.tipoModal_IdCuadrilla = tipo;
      //   if (this.tipoModal_IdCuadrilla != 0) {
      //     this.getCuadrillabyID(tipo);
      //   } else {
      //     this.empleados = [];
      //     this.contratistaSeleccion = [];
      //   }
      this.formDialog = "Ingrese los datos para concluir la tarea";
      console.log("Los datos de la tarea son");
      console.log(this.datosTarea);
      console.log(this.datosTarea.identificador);
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
video {
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-bottom: 16px;
}
</style>
